import api from "./api";
import API_URLS from "../../constants/api-urls";
import axios from "axios";
import storage from "../../utils/storage";

export default class BottleApi {
  getBottleDetail(payload) {
    let bottleNo = payload.bottle_no;
    let url = `${API_URLS.URL.bottle.getBottleDetail.replace(":bottle_no", bottleNo)}`;
    url += `?captcha_token=${payload.captcha_token}`;
    console.log(url);
    return api.get(url);
  }
  createBottleFeedback(bottle_no, access_token,payload) {
    let url = `${API_URLS.BASE}${API_URLS.URL.Feedback.createFeedback.replace(':bottle_no', bottle_no)}`;
    const headers = {
      "temp-token": access_token
    }
    return axios.post(url, payload, {
      headers,
    });
  }
}